import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DatePickerModule } from 'primeng/datepicker';
import { TableModule } from 'primeng/table';

@Component({
  selector: 'app-custom-date-time-range-filter',
  templateUrl: './custom-date-time-range-filter.component.html',
  styleUrls: ['./custom-date-time-range-filter.component.scss'],
  standalone: true,
  imports: [TableModule, FormsModule, DatePickerModule, ReactiveFormsModule]
})
export class CustomDateTimeRangeFilterComponent {
  @Input() field!: string;
  @Input() control!: FormControl;
  @Input() controlAlter!: FormControl;

  @Output() onChangeDateTimeRangeFilter = new EventEmitter<{ propertyName: string, valueFilter: any, valueAlterFilter: any }>();

  onDateTimeClose() {
    const start = this.control?.value;
    let end = this.controlAlter?.value;

    if (!(start instanceof Date)) {
      return;
    }

    if (!(end instanceof Date)) {
      end = new Date(start.getTime());
      this.controlAlter.setValue(end, { emitEvent: false });
    }

    this.onChangeDateTimeRangeFilter.emit({
      propertyName: this.field,
      valueFilter: this.formatDateTime(start, 0),
      valueAlterFilter: this.formatDateTime(end, 59)
    });
  }

  private formatDateTime(date: Date, seconds: number): string {
    const utc = new Date(date.getTime());
    utc.setUTCSeconds(seconds, 0);
    return utc.toISOString().replace(/\.\d{3}Z$/, 'Z');
  }
}
